import React, { createContext, useContext } from "react";
import type { TenantConfig } from "./tenants.config";

const TenantContext = createContext<TenantConfig | null>(null);

interface TenantProviderProps {
  config: TenantConfig;
  children: React.ReactNode;
}

/**
 * Provide the resolved TenantConfig to the React tree.
 * Wrap <App /> (or its children) with this so any component can call useTenant().
 */
export const TenantProvider: React.FC<TenantProviderProps> = ({
  config,
  children,
}) => {
  return (
    <TenantContext.Provider value={config}>{children}</TenantContext.Provider>
  );
};

/**
 * Read the current TenantConfig from context.
 * Must be used inside a <TenantProvider>.
 */
export function useTenant(): TenantConfig {
  const ctx = useContext(TenantContext);
  if (!ctx) {
    throw new Error("useTenant() must be used inside a <TenantProvider>.");
  }
  return ctx;
}
